import { jsx as _jsx } from "react/jsx-runtime";
import { SCALING_WHEN_WINDOW_WIDTH_LOWER, useMatchesMedia } from "@devowl-wp/web-cookie-banner";
import { useBanner, useBannerButtonCallbacks, CloseIcon } from "../../..";
const BannerCloseIcon = ()=>{
    var _document_getElementById;
    const { headerDesign: { fontColor, fontSize }, texts: { acceptEssentials }, activeAction, pageRequestUuid4, i18n: { close, closeWithoutSaving }, buttonClicked = "" } = useBanner();
    const { buttonClickedCloseIcon, closeIcon } = useBannerButtonCallbacks();
    const [isMobile] = useMatchesMedia([
        `(max-width: ${SCALING_WHEN_WINDOW_WIDTH_LOWER}px)`
    ]);
    return /*#__PURE__*/ _jsx(CloseIcon, {
        width: fontSize,
        color: fontColor,
        tooltipText: activeAction ? activeAction === "change" ? closeWithoutSaving : close : acceptEssentials,
        tooltipAlways: isMobile,
        framed: buttonClicked === buttonClickedCloseIcon,
        renderInContainer: (_document_getElementById = document.getElementById(pageRequestUuid4)) == null ? void 0 : _document_getElementById.querySelector("dialog"),
        onClick: closeIcon
    });
};
export { BannerCloseIcon };
